// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    chain as PlaceOrderChain,
    DispatchCompletePlaceOrder,
    SendTracking,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";
import { xGaState } from '@plumberssupply/App/Store/Reducers/xGA';
import { getDataLayer } from "@plumberssupply/App/Utilities/DataLayer";

export const _GaPlaceOrder: typeof SendTracking = props => {
    const state = props.getState() as xGaState;
    const session = getSession(state);

    if (state.xGA.purchaseEvent) {
        const dataLayer = getDataLayer();

        if (!dataLayer) {
            return;
        }
        const { apiResult } = props;

        const googleAnalyticsData = {
            event: "purchase",
            transcation_id: apiResult.cart.orderNumber,
            affiliation: apiResult.billTo?.companyName,
            value: apiResult.cart.orderSubTotal,
            tax: apiResult.cart.totalTax,
            shipping: apiResult.cart.shippingAndHandling,
            ...(session.userProfileId !== null ? { authenticated: true, userId: session.userProfileId } : { authenticated: false }),
            items: props.cartToUpdate.cartLines?.map(cartLine => (
                {
                    item_name: cartLine.shortDescription,
                    item_id: cartLine.erpNumber,
                    price: cartLine.pricing?.unitNetPrice,
                    quantity: cartLine.qtyOrdered,
                    item_brand: state.xGA.includeProductBrand
                        ? cartLine.brand?.name || ""
                        : undefined,
                    item_category: state.xGA.includeProductCategory
                        ? cartLine.properties?.["category"] || ""
                        : undefined,
                    item_list_id: state.xGA.includeProductCategory
                        ? cartLine.properties?.["categoryId"] || ""
                        : undefined,
                }
            ))
        }

        dataLayer.push(googleAnalyticsData);
    }
};

replaceInChain(PlaceOrderChain, SendTracking, _GaPlaceOrder);
// replaced DispatchCompletePlaceOrder to fix issue of empty cart line after place order
// DispatchCompletePlaceOrder will be dispatched on placeOrder onSuccess
replaceInChain(PlaceOrderChain, DispatchCompletePlaceOrder, () => {});